import { render, staticRenderFns } from "./S2STurnPurcIn.vue?vue&type=template&id=195a05f3"
import script from "./S2STurnPurcIn.vue?vue&type=script&lang=js"
export * from "./S2STurnPurcIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports